module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAARVBMVEUAAAAAfekAfOoAfOgAfekAfekAfekAfOkAfObq8/4Afen/R0f+SUnr5O77ZGbxuL+02Pns3Obvxc31l5z5eHv6cHLyrLMTcqAcAAAACXRSTlMA8vknra6JiClfal0jAAAA0ElEQVRo3u3Zyw6DIBCFYVFsdait177/o5ZVTwObkgxGyPlXuvGLtyHRhjH2f501opqxQ2SA0GO6ALGSIRsgRmQeVZtFTIB4d1RORIgQIUKECBEi10eWbc2PHO7x+u5M+7HkQHYHZXo6t6kiOLBXsLnmQKCAU0agwFBHoLxhaCNQHAx9BIo3ikd+LlfRNz54hIt9GaOxUuyAjEZ9sYtWPWs8ESJEiBAhQkQBOf1bvZUM9Wf+P4HSG2WiHxrGGKuwWyvptfc0BEaScsEzYYzV2Aeih9ZC1Df2MgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/SharePrinting/features_1.png
// module id = is+u
// module chunks = 10